module.exports = __webpack_public_path__ + "img/logo-company.e092a9c8.png";